<template>
  <div id="app">
    <top-bar></top-bar>
    <router-view></router-view>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import TopBar from './components/TopBar'
import FooterBar from './components/FooterBar'

export default {
  name: 'app',
  components: {
    TopBar,
    FooterBar
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Dosis|Open+Sans');
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  background-color: #3e4141;
  width: 100%;
  height: 100%;
  padding-top: 70px;
}

.title {
  font-family: 'Dosis', sans-serif;
  font-weight: 500;
  font-size: 400%;
}

.text-justified {
  text-align: justify;
}

.left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.breadcrumb {
  background-color: #2b2c2c !important;
  color: #ffffff;
}

ul#no-bullet {
  list-style-type: none;
  list-style: none;
  padding-left: 0;
}
.page-container{
  background-color: #2b2c2c;
  height: 100%;
}

.listGroup{
  background-color: #2b2c2c !important;
  border-color: #43a5d2 !important;
}

hr {
  border-color: #43a5d2 !important;
}

.indent{
  padding-left:15px;
}

.thumbnail {
  background-color: #43a5d2 !important;
  border-color: #134c72 !important;
}

.button {
  background-color: #43a5d2 !important;
  border-color: #134c72 !important;
}

.page-item {
  background-color: #43a5d2 !important;
}

.page-link {
  background-color: #2b2c2c !important;
  color: #ffffff !important;
  border-color: #43a5d2 !important;
}

.page-item.active .page-link {
    z-index: 1 !important;
    color: #fff !important;
    background-color: #43a5d2 !important;
    border-color: #43a5d2 !important;
}

.fa-spin{
  color: #43a5d2;
}

.examples{
  background-color: #2b2c2c;
  background-color: #134c72;
  background-color: #16709a;
  background-color: #43a5d2;
}

.bigIcon {
  font-size: 72px;
  /* padding-right: 50px; */
}

.center{
  align-content: center;
}

.flex-container {
  display: flex;
  align-items: center;
}
.flex-container > div {
  padding: 10px;
}

@font-face {
  font-family: 'Exurgo_Icons';
  src:  url('./fonts/Exurgo_Icons.eot?v1iq4t');
  src:  url('./fonts/Exurgo_Icons.eot?v1iq4t#iefix') format('embedded-opentype'),
    url('./fonts/Exurgo_Icons.ttf?v1iq4t') format('truetype'),
    url('./fonts/Exurgo_Icons.woff?v1iq4t') format('woff'),
    url('./fonts/Exurgo_Icons.svg?v1iq4t#Exurgo_Icons') format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^="icon-"], [class*=" icon-"] {
  font-family: 'Exurgo_Icons' !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-Respec:before {
  content: "\e900";
}
.icon-DataCore:before {
  content: "\e901";
}
.icon-Skill_MachineLearning:before {
  content: "\e902";
}
.icon-StatMod_ShieldBash:before {
  content: "\e903";
}
.icon-Icon_Hook_ShieldGrab:before {
  content: "\e904";
}
.icon-Icon_Hook_EnemyGrab:before {
  content: "\e905";
}
.icon-Icon_Hook_Dash:before {
  content: "\e906";
}
.icon-Skill_CombatAnalyser:before {
  content: "\e907";
}
.icon-StatMod_Reflect:before {
  content: "\e908";
}
.icon-Skill_Reflect2:before {
  content: "\e909";
}
.icon-Skill_ActiveReload:before {
  content: "\e90a";
}
.icon-Icon_Key:before {
  content: "\e90b";
}
.icon-Skill_NanoRecycler:before {
  content: "\e90c";
}
.icon-Skill_DashNova:before {
  content: "\e90d";
}
.icon-Icon_Credit:before {
  content: "\e90e";
}
.icon-Stat_StatusPotencyUp:before {
  content: "\e90f";
}
.icon-Stat_CriticalHitChance:before {
  content: "\e910";
}
.icon-Stat_CriticalHitDamage:before {
  content: "\e911";
}
.icon-Stat_SpecialDamageUp:before {
  content: "\e912";
}
.icon-Stat_ShieldBashDamageUp:before {
  content: "\e913";
}
.icon-Skill_HookRangeUp:before {
  content: "\e914";
}
.icon-Stat_GunDamageUp:before {
  content: "\e915";
}
.icon-StatMod_Energy:before {
  content: "\e916";
}
.icon-StatMod_EnergyRechargeUp:before {
  content: "\e917";
}
.icon-StatMod_EnergyUp:before {
  content: "\e918";
}
.icon-Icon_Shield_1:before {
  content: "\e919";
}
.icon-Icon_Shield_2:before {
  content: "\e91a";
}
.icon-Icon_Shield_3:before {
  content: "\e91b";
}
.icon-Icon_Shield_4:before {
  content: "\e91c";
}
.icon-Icon_Shield_5:before {
  content: "\e91d";
}
.icon-Icon_Shield_6:before {
  content: "\e91e";
}
.icon-SAmmoMod_Fire:before {
  content: "\e91f";
}
.icon-SAmmoMod_Cryo:before {
  content: "\e920";
}
.icon-SAmmoMod_Shock:before {
  content: "\e921";
}
.icon-SAmmoMod_Corrosive:before {
  content: "\e922";
}
.icon-SAmmoMod_Explosive:before {
  content: "\e923";
}
.icon-LoadOut:before {
  content: "\e924";
}
.icon-Settings:before {
  content: "\e925";
}
.icon-Stats:before {
  content: "\e926";
}
.icon-ShieldMod_None:before {
  content: "\e927";
}
.icon-ShieldMod_Fire:before {
  content: "\e928";
}
.icon-ShieldMod_Cryo:before {
  content: "\e929";
}
.icon-ShieldMod_Shock:before {
  content: "\e92a";
}
.icon-ShieldMod_Corrosive:before {
  content: "\e92b";
}
.icon-ShieldMod_Explosive:before {
  content: "\e92c";
}
.icon-StatMod_StabilityUp:before {
  content: "\e92d";
}
.icon-FireMod_Semi:before {
  content: "\e92e";
}
.icon-FireMod_Burst:before {
  content: "\e92f";
}
.icon-FireMod_Auto:before {
  content: "\e930";
}
.icon-FireMod_Charge:before {
  content: "\e931";
}
.icon-SpreadMod_Double:before {
  content: "\e932";
}
.icon-SpreadMod_Scatter:before {
  content: "\e933";
}
.icon-ProjectileMod_Beam:before {
  content: "\e934";
}
.icon-ProjectileMod_Bullet:before {
  content: "\e935";
}
.icon-ProjectileMod_Guass:before {
  content: "\e936";
}
.icon-ProjectileMod_Plasma:before {
  content: "\e937";
}
.icon-SpecialWeaponMod_GranadeLauncher:before {
  content: "\e938";
}
.icon-SpecialWeaponMod_RocketLauncher:before {
  content: "\e939";
}
.icon-SpecialWeaponMod_StingerLauncher2:before {
  content: "\e93a";
}
.icon-SpecialWeaponMod_HydraLauncher:before {
  content: "\e93b";
}
.icon-AmmoMod_None:before {
  content: "\e93c";
}
.icon-AmmoMod_Fire:before {
  content: "\e93d";
}
.icon-AmmoMod_Cryo:before {
  content: "\e93e";
}
.icon-AmmoMod_Shock_2:before {
  content: "\e93f";
}
.icon-AmmoMod_Corrosive_2:before {
  content: "\e940";
}
.icon-AmmoMod_Explosive:before {
  content: "\e941";
}
.icon-StatMod_AccuracyUp:before {
  content: "\e942";
}
.icon-StatMod_AmmoUp:before {
  content: "\e943";
}
.icon-StatMod_BulletSpeedUp:before {
  content: "\e944";
}
.icon-StatMod_DamageUp:before {
  content: "\e945";
}
.icon-StatMod_HealthUp:before {
  content: "\e946";
}
.icon-StatMod_ReloadSpeedUp:before {
  content: "\e947";
}
.icon-StatMod_ShieldRechargeUp:before {
  content: "\e948";
}
.icon-StatMod_ShieldUp:before {
  content: "\e949";
}
.icon-StatMod_SpecialAmmoUp:before {
  content: "\e94a";
}
.icon-Icon_Boss_2:before {
  content: "\e94b";
}

</style>



// WEBPACK FOOTER //
// src/App.vue